import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components";
import FormAddStation from './FormMgtStation'

import Actions from "../../redux/actions";
import AuthService from '../../service/Auth'
import Service from '../../service/Mgt-station'
import Map from "../../component/map/Index"

const Container = styled.div`
    width: 100%;

    .map{
        height: 400px;
        & > * { width: 100%; }
    }

    .form-container{
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
        width: 50%;

        @media only screen and (max-width: 768px){
            width: 80%;
        }
        
        @media only screen and (max-width: 450px){
            width: 80%;
        }

        @media only screen and (max-width: 376px){
            width: 100%;
        }

        @media only screen and (min-width: 1200px){
            width: 70%;
        }
    }
`;

export default function Index(props) {
    const { stationId } = useParams()
    const [permission, setPermission] = useState('')
    const currentLocation = useSelector(state => state.mgtStation.currentLocation)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(Actions.master.setPath("/mgt-station"))
        const init = async() =>{
            let permissions = await AuthService.permission('mgt-station')
            setPermission(permissions)
            if(stationId){
                let result = await Service.getDetail(stationId)
                if(result) {
                    dispatch(Actions.MgtStation.setCurrentLocation({lat: result.gps_lat, lng: result.gps_long}))
                    dispatch(Actions.MgtStation.setTempForm(result))
                }
            }else{
                dispatch(Actions.MgtStation.setCurrentLocation({lat: null, lng: null}))
                dispatch(Actions.MgtStation.setTempForm({}))
            }
        }

        init()
    }, [dispatch, stationId])

    return (
        <Container  className={"section-mgt-station" + (props.className ? props.className : "")}>
            <div className="page-title">
                <img src='/image/railway-station.png' alt="icon-railway-station"/>
                <span>จัดการสถานี</span>
            </div>
            <div className="map">
                <Map mode={"location"} location={currentLocation}/>
            </div>
            <div className="form-container">
                <div className="section-heading">
                    <p>ข้อมูลสถานี</p>
                </div>
                <FormAddStation permission={permission} stationId={stationId}/>
            </div>
        </Container>
    )
}
